// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yN-z","twoColumnImage":"zN-z"};